export default __webpack_public_path__ + "static/media/group-631@2x.6cf0b0cd.png";